import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { UpdateDatabaseListComponent } from './components/update-database-list/update-database-list.component';

const routes: Routes = [
  {
    path: 'updateDatabase/list',
    component: UpdateDatabaseListComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Atualização de Base local'
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UpdateDatabaseRoutingModule { }
